class BFTimer extends HTMLElement {
  connectedCallback() {
    this.endDate = new Date(this.getAttribute("end-date"));

    this.$days = this.querySelector("[data-days]");
    this.$hours = this.querySelector("[data-hours]");
    this.$minutes = this.querySelector("[data-minutes]");
    this.$seconds = this.querySelector("[data-seconds]");

    this.start();
  }

  start() {
    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  update() {
    const now = new Date();
    let diff = this.endDate - now;

    if (diff <= 0) {
      diff = 0;
      clearInterval(this.interval);
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    this.$days.textContent = String(days).padStart(2, "0");
    this.$hours.textContent = String(hours).padStart(2, "0");
    this.$minutes.textContent = String(minutes).padStart(2, "0");
    this.$seconds.textContent = String(seconds).padStart(2, "0");
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define("bf-timer", BFTimer);
